"use client";
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";
import { FaGithub } from "react-icons/fa";
import Link from "next/link";
import Swal from "sweetalert2";
import Image from "next/image";
import Preloader from "@/components/sharepage/Preloader";

const Contact = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    emailjs
      .send(
        process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID,
        process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID,
        data,
        process.env.NEXT_PUBLIC_EMAILJS_USER_ID,
      )
      .then((result) => {
        if (result.status === 200) {
          Swal.fire({
            title: "Good job!",
            text: "Email sent successfully",
            icon: "success",
          });
          reset();
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "Cool",
        });
      });
  };

  // Animation variants
  /*  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  }; */

  /*  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  }; */

  /*   const formItem = {
    hidden: { opacity: 0, x: -20 },
    show: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  }; */

  /*   const socialIcon = {
    hover: {
      scale: 1.1,
      transition: { duration: 0.2 },
    },
    tap: { scale: 0.95 },
  };
 */
  return (
    <>
      <Preloader></Preloader>
      <section className="relative z-10 overflow-hidden py-20 dark:bg-dark lg:py-24">
        <h1
          className="text-center pt-5 md:pt-8 pb-5 md:pb-10 text-xl md:text-2xl lg:text-4xl text-white font-bold"
          // initial={{ opacity: 0, y: -20 }}
          // animate={{ opacity: 1, y: 0 }}
          // transition={{ duration: 0.5 }}
        >
          Contact Me
        </h1>

        <div className="">
          <div
            className="-mx-4 flex flex-wrap lg:justify-between"
            // variants={container}
            // initial="hidden"
            // whileInView="show"
            // viewport={{ once: true }}
          >
            <div className="w-full px-4 lg:w-1/2">
              <div
                className="mb-12 lg:mb-0"
                //  variants={container}
              >
                <div
                  className="mb-8 bg-base-300 p-3 hover:shadow-sm hover:shadow-rose-500 hover:transition-all hover:duration-1000 rounded-lg flex w-full lg:max-w-[500px]"
                  // variants={item}
                  // whileHover={{ scale: 1.02 }}
                >
                  <div className="mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded sm:h-[70px] sm:max-w-[70px]">
                    <Image
                      className="w-full h-full"
                      src="/assist/location-pin.gif"
                      alt="location"
                      width={20}
                      height={20}
                    />
                  </div>
                  <div className="w-full">
                    <h1 className="mb-1 text-xl font-bold text-white">
                      Location
                    </h1>
                    <p className="text-[11px] sm:text-base text-body-color">
                      Dhaka, Bangladesh
                    </p>
                  </div>
                </div>

                <div
                  className="mb-8 bg-base-300 p-3 hover:shadow-sm hover:shadow-rose-500 hover:transition-all hover:duration-1000 flex w-full lg:max-w-[500px] rounded-lg"
                  // variants={item}
                  // whileHover={{ scale: 1.02 }}
                >
                  <div className="mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded sm:h-[70px] sm:max-w-[70px]">
                    <Image
                      className="w-full h-full"
                      src="/assist/24-hours.gif"
                      alt="Phone"
                      width={20}
                      height={20}
                    />
                  </div>
                  <div className="w-full">
                    <h1 className="mb-1 text-xl font-bold text-white">Phone</h1>
                    <p className="text-[11px] sm:text-base text-body-color">
                      01879746696
                    </p>
                  </div>
                </div>

                <div
                  className="mb-8 bg-base-300 p-3 hover:shadow-sm hover:shadow-rose-500 hover:transition-all hover:duration-1000 flex w-full lg:max-w-[500px] rounded-lg"
                  // variants={item}
                  // whileHover={{ scale: 1.02 }}
                >
                  <div className="mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded sm:h-[70px] sm:max-w-[70px]">
                    <Image
                      className="w-full h-full"
                      src="/assist/email-file.gif"
                      alt="email"
                      width={20}
                      height={20}
                    />
                  </div>
                  <div className="w-full">
                    <h1 className="mb-1 text-xl font-bold text-white">Email</h1>
                    <p className="text-[11px] sm:text-base text-body-color">
                      mdsaifulislamrafsan099@gmail.com
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="lg:max-w-[500px] bg-base-300 hover:shadow-rose-500 hover:shadow-sm rounded-lg p-5"
                // variants={item}
                // whileHover={{ scale: 1.01 }}
              >
                <h1 className="mb-1 text-xl font-bold text-white">Follow Me</h1>
                <ul
                  className="flex flex-wrap gap-x-8 gap-4 my-4"
                  // variants={container}
                >
                  {[
                    {
                      title: "facebook",
                      href: "https://www.facebook.com/Mdsaifulislam.Rafsan",
                      icon: (
                        <svg
                          className="relative z-10 fill-gray-900 transition-all duration-300 group-hover:fill-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width={28}
                          height={28}
                          viewBox="0 0 72 72"
                          fill="none"
                        >
                          <path
                            d="M46.4927 38.6403L47.7973 30.3588H39.7611V24.9759C39.7611 22.7114 40.883 20.4987 44.4706 20.4987H48.1756V13.4465C46.018 13.1028 43.8378 12.9168 41.6527 12.8901C35.0385 12.8901 30.7204 16.8626 30.7204 24.0442V30.3588H23.3887V38.6403H30.7204V58.671H39.7611V38.6403H46.4927Z"
                            fill=""
                          />
                        </svg>
                      ),
                      bg: "bg-blue-500",
                    },
                    {
                      title: "github",
                      href: "https://github.com/mdsaifulislamrafsan",
                      icon: (
                        <FaGithub className="text-gray-900 text-xl relative z-10 transition-all duration-300 group-hover:text-white" />
                      ),
                      bg: "bg-gray-800",
                    },
                    {
                      title: "linkedin",
                      href: "https://www.linkedin.com/in/mdsaifulislamrafsan/",
                      icon: (
                        <svg
                          className="fill-gray-900 relative z-10 transition-all duration-300 group-hover:fill-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width={28}
                          height={28}
                          viewBox="0 0 72 72"
                          fill="none"
                        >
                          <path
                            d="M24.7612 55.999V28.3354H15.5433V55.999H24.7621H24.7612ZM20.1542 24.5591C23.3679 24.5591 25.3687 22.4348 25.3687 19.7801C25.3086 17.065 23.3679 15 20.2153 15C17.0605 15 15 17.065 15 19.7799C15 22.4346 17.0001 24.5588 20.0938 24.5588H20.1534L20.1542 24.5591ZM29.8633 55.999H39.0805V40.5521C39.0805 39.7264 39.1406 38.8985 39.3841 38.3088C40.0502 36.6562 41.5668 34.9455 44.1138 34.9455C47.4484 34.9455 48.7831 37.4821 48.7831 41.2014V55.999H58V40.1376C58 31.6408 53.4532 27.6869 47.3887 27.6869C42.4167 27.6869 40.233 30.4589 39.0198 32.347H39.0812V28.3364H29.8638C29.9841 30.9316 29.8631 56 29.8631 56L29.8633 55.999Z"
                            fill=""
                          />
                        </svg>
                      ),
                      bg: "bg-[#006699]",
                    },
                    {
                      title: "gmail",
                      href: "mailto:mdsaifulislamrafsan099@gmail.com",
                      icon: (
                        <svg
                          className="fill-gray-900 relative z-10 transition-all duration-300 group-hover:fill-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 54 41"
                          fill="none"
                        >
                          <path
                            d="M4.00654 40.1236H12.4893V19.5227L0.371094 10.4341V36.4881C0.371094 38.4997 2.00099 40.1236 4.00654 40.1236Z"
                            fill=""
                          />
                          <path
                            d="M41.5732 40.1236H50.056C52.0676 40.1236 53.6914 38.4937 53.6914 36.4881V10.4341L41.5732 19.5227"
                            fill=""
                          />
                          <path
                            d="M41.5732 3.7693V19.5229L53.6914 10.4343V5.58702C53.6914 1.09118 48.5594 -1.47181 44.9663 1.22448"
                            fill=""
                          />
                          <path
                            d="M12.4893 19.5227V3.76904L27.0311 14.6754L41.5729 3.76904V19.5227L27.0311 30.429"
                            fill=""
                          />
                          <path
                            d="M0.371094 5.58702V10.4343L12.4893 19.5229V3.7693L9.09617 1.22448C5.49708 -1.47181 0.371094 1.09118 0.371094 5.58702Z"
                            fill=""
                          />
                        </svg>
                      ),
                      bg: "bg-red-500",
                    },
                    {
                      title: "whatsapp",
                      href: "https://wa.me/+8801879746696",
                      icon: (
                        <svg
                          className="fill-gray-900 relative z-10 transition-all duration-300 group-hover:fill-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 71 72"
                          fill="none"
                        >
                          <path
                            d="M12.5762 56.8405L15.8608 44.6381C13.2118 39.8847 12.3702 34.3378 13.4904 29.0154C14.6106 23.693 17.6176 18.952 21.9594 15.6624C26.3012 12.3729 31.6867 10.7554 37.1276 11.1068C42.5685 11.4582 47.6999 13.755 51.5802 17.5756C55.4604 21.3962 57.8292 26.4844 58.2519 31.9065C58.6746 37.3286 57.1228 42.7208 53.8813 47.0938C50.6399 51.4668 45.9261 54.5271 40.605 55.7133C35.284 56.8994 29.7125 56.1318 24.9131 53.5513L12.5762 56.8405ZM25.508 48.985L26.2709 49.4365C29.7473 51.4918 33.8076 52.3423 37.8191 51.8555C41.8306 51.3687 45.5681 49.5719 48.4489 46.7452C51.3298 43.9185 53.1923 40.2206 53.7463 36.2279C54.3002 32.2351 53.5143 28.1717 51.5113 24.6709C49.5082 21.1701 46.4003 18.4285 42.6721 16.8734C38.9438 15.3184 34.8045 15.0372 30.8993 16.0736C26.994 17.11 23.5422 19.4059 21.0817 22.6035C18.6212 25.801 17.2903 29.7206 17.2963 33.7514C17.293 37.0937 18.2197 40.3712 19.9732 43.2192L20.4516 44.0061L18.6153 50.8167L25.508 48.985Z"
                            fill=""
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M44.0259 36.8847C43.5787 36.5249 43.0549 36.2716 42.4947 36.1442C41.9344 36.0168 41.3524 36.0186 40.793 36.1495C39.9524 36.4977 39.4093 37.8134 38.8661 38.4713C38.7516 38.629 38.5833 38.7396 38.3928 38.7823C38.2024 38.8251 38.0028 38.797 37.8316 38.7034C34.7543 37.5012 32.1748 35.2965 30.5122 32.4475C30.3704 32.2697 30.3033 32.044 30.325 31.8178C30.3467 31.5916 30.4555 31.3827 30.6286 31.235C31.2344 30.6368 31.6791 29.8959 31.9218 29.0809C31.9756 28.1818 31.7691 27.2863 31.3269 26.5011C30.985 25.4002 30.3344 24.42 29.4518 23.6762C28.9966 23.472 28.4919 23.4036 27.9985 23.4791C27.5052 23.5546 27.0443 23.7709 26.6715 24.1019C26.0242 24.6589 25.5104 25.3537 25.168 26.135C24.8256 26.9163 24.6632 27.7643 24.6929 28.6165C24.6949 29.0951 24.7557 29.5716 24.8739 30.0354C25.1742 31.1497 25.636 32.2144 26.2447 33.1956C26.6839 33.9473 27.163 34.6749 27.6801 35.3755C29.3607 37.6767 31.4732 39.6305 33.9003 41.1284C35.1183 41.8897 36.42 42.5086 37.7799 42.973C39.1924 43.6117 40.752 43.8568 42.2931 43.6824C43.1711 43.5499 44.003 43.2041 44.7156 42.6755C45.4281 42.1469 45.9995 41.4518 46.3795 40.6512C46.6028 40.1675 46.6705 39.6269 46.5735 39.1033C46.3407 38.0327 44.9053 37.4007 44.0259 36.8847Z"
                            fill=""
                          />
                        </svg>
                      ),
                      bg: "bg-green-400",
                    },
                  ].map((social) => (
                    <li
                      key={social?.title}
                      // variants={item}
                    >
                      <Link
                        aria-label={social?.title}
                        href={social?.href}
                        target="_blank"
                      >
                        <div
                          className="w-10 h-10 flex items-center justify-center relative overflow-hidden bg-white shadow-md group transition-all duration-300"
                          // variants={socialIcon}
                          // whileHover="hover"
                          // whileTap="tap"
                        >
                          {social.icon}
                          <div
                            className={`absolute top-full left-0 w-full h-full ${social.bg} z-0 transition-all duration-500 group-hover:top-0`}
                          ></div>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="w-full px-4 pt-10 md:pt-0 lg:w-1/2">
              <div
                className="relative  rounded-lg hover:shadow-sm hover:shadow-rose-500 hover:transition-all hover:duration-1000 bg-base-300 p-8 shadow-lg sm:p-12"
                // initial={{ opacity: 0, y: 20 }}
                // animate={{ opacity: 1, y: 0 }}
                // transition={{ delay: 0.4 }}
              >
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  // variants={container}
                >
                  <div
                    className="mb-6"
                    // variants={formItem}
                  >
                    <input
                      type="text"
                      placeholder="Your Name"
                      name="name"
                      {...register("name", { required: true })}
                      className="w-full rounded border border-stroke px-[14px] py-3 text-base text-body-color outline-none focus:border-rose-500 dark:border-dark-3 dark:bg-dark"
                    />
                    {errors.name && (
                      <span className="text-red-500">
                        This field is required
                      </span>
                    )}
                  </div>
                  <div className="mb-6">
                    <input
                      type="number"
                      placeholder="Your Phone"
                      name="name"
                      {...register("phone", { required: true })}
                      className="w-full rounded border border-stroke px-[14px] py-3 text-base text-body-color outline-none focus:border-rose-500 dark:border-dark-3 dark:bg-dark"
                    />
                    {errors.phone && (
                      <span className="text-red-500">
                        This field is required
                      </span>
                    )}
                  </div>
                  <div
                    className="mb-6"
                    // variants={formItem}
                  >
                    <input
                      type="email"
                      placeholder="Your email"
                      name="email"
                      {...register("email", { required: true })}
                      className="w-full rounded border border-stroke px-[14px] py-3 text-base text-body-color outline-none focus:border-rose-500 dark:border-dark-3 dark:bg-dark"
                    />
                    {errors.email && (
                      <span className="text-red-500">
                        This field is required
                      </span>
                    )}
                  </div>

                  <div
                    className="mb-6"
                    // variants={formItem}
                  >
                    <textarea
                      rows="6"
                      placeholder="Your Message"
                      {...register("details", { required: true })}
                      className="w-full resize-none rounded border border-stroke px-[14px] py-3 text-base text-body-color outline-none focus:border-rose-500 dark:border-dark-3 dark:bg-dark"
                    />
                    {errors.details && (
                      <span className="text-red-500">
                        This field is required
                      </span>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-6 rounded bg-gradient-to-tr from-rose-600 via-rose-500 to-rose-400 shadow-lg shadow-rose-500/50 p-3 text-white transition hover:bg-opacity-90"
                    // whileHover={{ scale: 1.02 }}
                    // whileTap={{ scale: 0.98 }}
                    // variants={formItem}
                  >
                    Send Message
                  </button>
                </form>

                <div>
                  <div className="absolute -right-9 -top-10 -z-10">
                    <svg
                      width={100}
                      height={100}
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 100C0 44.7715 0 0 0 0C55.2285 0 100 44.7715 100 100C100 100 100 100 0 100Z"
                        fill="#3056D3"
                      />
                    </svg>
                  </div>

                  <div className="absolute -bottom-7 -left-7 -z-10">
                    <Image
                      src="/assist/svgviewer-png-output.png"
                      alt="decoration"
                      width={107}
                      height={134}
                      priority
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
